'use client';

import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine,  } from 'recharts';

// Backend integration point: replace with real 7-day conversion analytics
const trendData = [
  { day: 'Lun 14', leads: 38, conversiones: 8, ingresos: 4.0 },
  { day: 'Mar 15', leads: 52, conversiones: 14, ingresos: 7.0 },
  { day: 'Mié 16', leads: 41, conversiones: 9, ingresos: 4.5 },
  { day: 'Jue 17', leads: 67, conversiones: 18, ingresos: 9.0 },
  { day: 'Vie 18', leads: 44, conversiones: 11, ingresos: 5.5 },
  { day: 'Sáb 19', leads: 29, conversiones: 6, ingresos: 3.0 },
  { day: 'Dom 20', leads: 47, conversiones: 11, ingresos: 5.5 },
];

const CustomTooltip = ({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: Array<{ name: string; value: number; color: string }>;
  label?: string;
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-elevated border border-border rounded-lg p-3 shadow-card-hover min-w-[160px]">
        <p className="text-xs font-semibold text-foreground mb-2">{label}</p>
        {payload.map((p) => (
          <div key={`tooltip-${p.name}`} className="flex justify-between gap-4 text-xs">
            <span className="text-muted-foreground">{p.name}</span>
            <span className="font-semibold font-tabular" style={{ color: p.color }}>
              {p.name === 'Ingresos €' ? `€${p.value.toFixed(1)}` : p.value}
            </span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default function ConversionTrendChart() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-sm font-semibold text-foreground">
            Rendimiento Últimos 7 Días
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Leads captados, conversiones e ingresos por día
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1.5 text-2xs text-muted-foreground">
            <span className="w-3 h-0.5 bg-primary rounded inline-block" />
            Leads
          </span>
          <span className="flex items-center gap-1.5 text-2xs text-muted-foreground">
            <span className="w-3 h-0.5 bg-accent rounded inline-block" />
            Conversiones
          </span>
          <span className="flex items-center gap-1.5 text-2xs text-muted-foreground">
            <span className="w-3 h-0.5 bg-warning rounded inline-block" />
            Ingresos €
          </span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={trendData} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis
            dataKey="day"
            tick={{ fill: 'var(--muted-foreground)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: 'var(--muted-foreground)', fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <ReferenceLine y={10} stroke="var(--warning)" strokeDasharray="4 4" strokeOpacity={0.4} />
          <Line
            type="monotone"
            dataKey="leads"
            name="Leads"
            stroke="var(--primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--primary)', r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line
            type="monotone"
            dataKey="conversiones"
            name="Conversiones"
            stroke="var(--accent)"
            strokeWidth={2}
            dot={{ fill: 'var(--accent)', r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line
            type="monotone"
            dataKey="ingresos"
            name="Ingresos €"
            stroke="var(--warning)"
            strokeWidth={2}
            strokeDasharray="5 3"
            dot={{ fill: 'var(--warning)', r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}